import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';

export class SpinnerService {

  private data$ = new BehaviorSubject<boolean>(null);
  spinner = this.data$.asObservable();

  public getSpinnerFlag(): Observable<boolean> {
    return this.spinner;
  }

  public setSpinnerFlag(flag: boolean) {
    this.data$.next(flag);
  }
}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspace/ng-labportal-prod-build/src/app/orders/search/spinner.service.ts